import { RootState } from '../types'
import { connect } from 'react-redux'
import { Action, Dispatch } from 'redux'
import ModalDialog from '../components/ModalDialog'
import { confirmModal, unsetModal } from '../actions/dialogActions'

export function mapStateToProps(rootState: RootState) {
  return {
    modal: rootState.modal,
  }
}

export function mapDispatchToProps(dispatch: Dispatch<Action>) {
  return {
    confirm: () => {
      dispatch(confirmModal())
    },
    decline: () => {
      dispatch(unsetModal())
    },
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalDialog)
